<script lang="ts" setup>
/**
 * @deprecated This component is deprecated. Use the new AbsIcon component directly.
 */
import { getBaseURL } from '@/addons/functions'
import { computed } from 'vue'

defineOptions({ name: 'FeIcon' })

const props = defineProps({
  icon: { type: String, default: null },
  className: { type: String, default: null },
  color: { type: String, default: '' },
  bgColor: { type: String, default: '' },
})

const iconPath = computed<string>(
  () => `${getBaseURL()}/assets/icons/${props.icon}.svg`,
)

// Make `fe-icon-color` and `fe-icon-bg-color`(used by outlined icons) work by updating the svg icon's `stroke` and `fill`.
const iconStyle = computed(() => {
  const style: Record<string, string> = {}
  if (props.color) {
    style['--abs-icon-color'] = props.color
  }
  if (props.bgColor) {
    style['--abs-icon-bg-color'] = props.bgColor
  }
  return style
})
</script>

<template>
  <span class="fe-icon">
    <ion-icon :icon="iconPath" :class="className" :style="iconStyle" />
  </span>
</template>

<style lang="scss" scoped>
.fe-icon {
  ion-icon {
    min-width: 1rem;
    min-height: 1rem;
  }
}
</style>
